import { authHelper } from '@utils/authHelper/AuthHelper'
import { Payee } from '@root/api/ump-catalog-manager'
import { NoticeType } from '../../Notice/types'
import { statusCodes } from '../types'

export const replaceSymbolsOld = (value: string | number) => parseFloat(value?.toString().replace(/[^\d]/g, '.'))

export const matchingTransferByStatus = {
  IN_PROGRESS: NoticeType.WAIT,
  EXECUTED: NoticeType.SUCCESS,
  REJECTED: NoticeType.ERROR,
}

export const getStatusName = (statusCode: number): string => {
  let status = 'Fail'

  Object.entries(statusCodes).forEach(([statusName, statusCodes]) => {
    if (statusCodes.includes(statusCode)) {
      status = statusName
    }
  })

  return status
}

export const replaceSymbols00 = (value: string | number) =>
  parseFloat(value?.toString().replace(/[^\d]/g, '.')).toFixed(2)

export const replaceSymbols = (value: string | number): number => {
  if (typeof value === 'number') {
    return Math.round(value * 100)
  }
  const cleanedValue = value?.replace(',', '.')

  return Math.round(parseFloat(cleanedValue) * 100)
}

export const getPcekZone = () => {
  const { isAuthenticated } = authHelper

  const isAuth = isAuthenticated()

  return isAuth ? 'b' : 'anonymous'
}

export const filterServicesForSearch = (services: Payee[], merchantAssociation: string) =>
  services.filter((serviceInfo) => {
    if (serviceInfo?.serviceId === merchantAssociation) {
      return false
    }

    if (serviceInfo?.features?.screenType || serviceInfo?.features?.merchant_association_for_WEB) return true

    if (!serviceInfo?.features?.merchant_association_for_WEB && !serviceInfo?.features?.screenType) {
      return !serviceInfo?.hidden
    }

    return false
  })
